import { ViewLevel } from '../Constants';
import ProgressBar from "./ProgessBar";
import { Link } from "react-router-dom";

function Objective(props) {
    const percentComplete = 
        props.year in props.data.progress
        ? Math.floor(props.data.progress[props.year].percentComplete / props.data.progress[props.year].weight) || 0
        : 0

    const progressBarElement =
        props.year in props.data.progress && !props.data.doNotCount
        ? <ProgressBar percentComplete={percentComplete} shrinkForNextButton={true} />
        : <div className="progress-bar shrink-for-next-button progress-bar-value">n/a</div>

    const nextLink =
        props.viewLevel >= ViewLevel.KeyResults
        ? <Link className="next" to={`/?y=${props.year}&o=${props.data.id}&v=${props.viewLevel}`}>❯</Link>
        : null;

    return (
        <div className="objective">
            <header>{props.data.name}</header>
            <div className="description">{props.data.description}</div>
            {progressBarElement}
            {nextLink}
        </div>
    );
}

export default Objective;
